export class BannerModel {
  constructor(data) {
    this.banner_id = data.banner_id;
    this.banner_title = data.banner_title;
    this.banner_subtitle = data.banner_subtitle;
    this.banner_action_url = data.banner_action_url;
    this.banner_url = data.banner_url;
  }

  static fromJson(json) {
    return new BannerModel(json);
  }

  static fromJsonList(jsonList) {
    return jsonList.map(json => BannerModel.fromJson(json));
  }
}
